export default __webpack_public_path__ + "assets/TD-d4f2e920031d9be30d556a13b65d6b64.svg";